import { ZT_ROOT_ADDRESS } from '@src/constants/urls';
import { isProduction } from '@src/constants';
import { getMockPassportAccount } from '../mock-passport-account';
import BusinessServiceFactory from '../business-service-factory';
import UnmountError from '@src/error/UnmountError';
import zt from './zt';
import ServiceResponseError from '@src/error/ServiceResponseError';

export default class ZtServiceFactory extends BusinessServiceFactory {
  /**
   * 获取默认实例方法, 用于非 component 中使用等情况
   * @type {import('@src/services/zt/services.d.ts').IGeneratedServices}
   */
  static getDefaultInstance() {
    if (!ZtServiceFactory._defaultServiceInstance) {
      ZtServiceFactory._defaultServiceInstance = new ZtServiceFactory().createService();
    }
    // noinspection JSValidateTypes
    return ZtServiceFactory._defaultServiceInstance;
  }

  constructor({ checkIfComponentUnmount } = {}) {
    super({
      /**
       * 队列映射
       * 详细请参考: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
       * @type {{'jx3/ticket190728/create_order': string}}
       */
      queueMap: {
        /* 'jx3/ticket190728/create_order': 'jx3master' */
      },
      /**
       * 缓存时间, 默认: 100ms
       */
      optimizeUsingCache: 100,

      /**
       * 请求是否携带 utm_source 字段名,
       * 如果设置了字符串, 则将自动上报该字段
       * 如果设置 undefined 或 null 或 false 或 '',则请求时候将不携带 utm_source
       */
      requestWithUtmSourceFieldName: '' /*'utm_source'*/
    });
    this.handleTestPassportAccount();
    this.handleCheckIfComponentUnmount(checkIfComponentUnmount);
  }

  /**
   * Injects the URL-specified full passport account as the simulated login identity for every ZT request.
   * A non-master URL carrying `?_mock_passport_account=<full-account>` (e.g. 18615625506) simulates
   * that account; without the parameter requests keep their cookie-login identity. The injection adds
   * the key unconditionally (not only where the generated contract declares a parameter slot) because
   * `team_config` documents no slot yet resolves the parameter server-side — verified 2026-09-09 that
   * it returns -10402 anonymously but succeeds with the parameter, which would otherwise fail the
   * Backpack page whose initialization requests it in parallel. The XPASS runtime account is
   * intentionally not read here: it only exposes masked accounts (e.g. 159***520) the backend
   * cannot resolve, which is why the earlier injection attempt never took effect.
   */
  handleTestPassportAccount() {
    if (isProduction) {
      return;
    }

    this.beforeRequests.push(({ url, params }) => {
      const mockPassportAccount = getMockPassportAccount();
      if (!mockPassportAccount) {
        return undefined;
      }

      return {
        url,
        params: {
          ...params,
          _mock_passport_account: mockPassportAccount
        }
      };
    });
  }

  /**
   * 处理检查组件是否被卸载
   * @private
   */
  handleCheckIfComponentUnmount(checkIfComponentUnmount) {
    if (!checkIfComponentUnmount) {
      return;
    }
    const action = () => {
      if (checkIfComponentUnmount() === true) {
        throw new UnmountError();
      }
    };
    this.beforeRequests.push(action);
    this.afterRequestSuccessList.push(action);
    this.afterRequestErrorList.push(action);
  }

  /**
   * 创建服务
   * @type {import('@src/services/zt/services.d.ts').IGeneratedServices}
   */
  createService() {
    return zt({ jsonp: ::this.request }, response => Promise.reject(new ServiceResponseError(response)), ZT_ROOT_ADDRESS);
  }
}
